// Translation resources, grouped by language and then by app area.
//
// Every user-facing string in the app is looked up through i18next using
// keys of the form "<area>.<section>.<key>", e.g. t("team.sessions.title").
// Each area lives in its own JSON file so translations stay manageable.
// English (en) is the source of truth; `npm run i18n:check` verifies every
// other language has the same keys, placeholders and plural forms.
//
// To add a new language (e.g. Italian):
//   1. Copy src/locales/en/ to src/locales/it/ and translate the values.
//   2. Import the files below and add an `it` entry to `resources`.
//   3. Add the language to SUPPORTED_LANGUAGES in src/i18n.js.

import enAdmin from "./en/admin.json";
import enAnalysis from "./en/analysis.json";
import enCaseDashboard from "./en/caseDashboard.json";
import enAuth from "./en/auth.json";
import enCommon from "./en/common.json";
import enDevices from "./en/devices.json";
import enDeviceTools from "./en/deviceTools.json";
import enNavigation from "./en/navigation.json";
import enSession from "./en/session.json";
import enSettings from "./en/settings.json";
import enTeam from "./en/team.json";
import enUtils from "./en/utils.json";
import enWearableOps from "./en/wearableOps.json";
import enWorkspace from "./en/workspace.json";

import frAdmin from "./fr/admin.json";
import frAnalysis from "./fr/analysis.json";
import frCaseDashboard from "./fr/caseDashboard.json";
import frAuth from "./fr/auth.json";
import frCommon from "./fr/common.json";
import frDevices from "./fr/devices.json";
import frDeviceTools from "./fr/deviceTools.json";
import frNavigation from "./fr/navigation.json";
import frSession from "./fr/session.json";
import frSettings from "./fr/settings.json";
import frTeam from "./fr/team.json";
import frUtils from "./fr/utils.json";
import frWearableOps from "./fr/wearableOps.json";
import frWorkspace from "./fr/workspace.json";

import esAdmin from "./es/admin.json";
import esAnalysis from "./es/analysis.json";
import esCaseDashboard from "./es/caseDashboard.json";
import esAuth from "./es/auth.json";
import esCommon from "./es/common.json";
import esDevices from "./es/devices.json";
import esDeviceTools from "./es/deviceTools.json";
import esNavigation from "./es/navigation.json";
import esSession from "./es/session.json";
import esSettings from "./es/settings.json";
import esTeam from "./es/team.json";
import esUtils from "./es/utils.json";
import esWearableOps from "./es/wearableOps.json";
import esWorkspace from "./es/workspace.json";

import deAdmin from "./de/admin.json";
import deAnalysis from "./de/analysis.json";
import deCaseDashboard from "./de/caseDashboard.json";
import deAuth from "./de/auth.json";
import deCommon from "./de/common.json";
import deDevices from "./de/devices.json";
import deDeviceTools from "./de/deviceTools.json";
import deNavigation from "./de/navigation.json";
import deSession from "./de/session.json";
import deSettings from "./de/settings.json";
import deTeam from "./de/team.json";
import deUtils from "./de/utils.json";
import deWearableOps from "./de/wearableOps.json";
import deWorkspace from "./de/workspace.json";

import afAdmin from "./af/admin.json";
import afAnalysis from "./af/analysis.json";
import afCaseDashboard from "./af/caseDashboard.json";
import afAuth from "./af/auth.json";
import afCommon from "./af/common.json";
import afDevices from "./af/devices.json";
import afDeviceTools from "./af/deviceTools.json";
import afNavigation from "./af/navigation.json";
import afSession from "./af/session.json";
import afSettings from "./af/settings.json";
import afTeam from "./af/team.json";
import afUtils from "./af/utils.json";
import afWearableOps from "./af/wearableOps.json";
import afWorkspace from "./af/workspace.json";

const resources = {
  en: {
    translation: {
      admin: enAdmin,
      analysis: enAnalysis,
      caseDashboard: enCaseDashboard,
      auth: enAuth,
      common: enCommon,
      devices: enDevices,
      deviceTools: enDeviceTools,
      navigation: enNavigation,
      session: enSession,
      settings: enSettings,
      team: enTeam,
      utils: enUtils,
      wearableOps: enWearableOps,
      workspace: enWorkspace,
    },
  },
  fr: {
    translation: {
      admin: frAdmin,
      analysis: frAnalysis,
      caseDashboard: frCaseDashboard,
      auth: frAuth,
      common: frCommon,
      devices: frDevices,
      deviceTools: frDeviceTools,
      navigation: frNavigation,
      session: frSession,
      settings: frSettings,
      team: frTeam,
      utils: frUtils,
      wearableOps: frWearableOps,
      workspace: frWorkspace,
    },
  },
  es: {
    translation: {
      admin: esAdmin,
      analysis: esAnalysis,
      caseDashboard: esCaseDashboard,
      auth: esAuth,
      common: esCommon,
      devices: esDevices,
      deviceTools: esDeviceTools,
      navigation: esNavigation,
      session: esSession,
      settings: esSettings,
      team: esTeam,
      utils: esUtils,
      wearableOps: esWearableOps,
      workspace: esWorkspace,
    },
  },
  de: {
    translation: {
      admin: deAdmin,
      analysis: deAnalysis,
      caseDashboard: deCaseDashboard,
      auth: deAuth,
      common: deCommon,
      devices: deDevices,
      deviceTools: deDeviceTools,
      navigation: deNavigation,
      session: deSession,
      settings: deSettings,
      team: deTeam,
      utils: deUtils,
      wearableOps: deWearableOps,
      workspace: deWorkspace,
    },
  },
  af: {
    translation: {
      admin: afAdmin,
      analysis: afAnalysis,
      caseDashboard: afCaseDashboard,
      auth: afAuth,
      common: afCommon,
      devices: afDevices,
      deviceTools: afDeviceTools,
      navigation: afNavigation,
      session: afSession,
      settings: afSettings,
      team: afTeam,
      utils: afUtils,
      wearableOps: afWearableOps,
      workspace: afWorkspace,
    },
  },
};

export default resources;
